/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NotificationEventType } from './NotificationEventType';
import {
    NotificationEventTypeFromJSON,
    NotificationEventTypeFromJSONTyped,
    NotificationEventTypeToJSON,
} from './NotificationEventType';

/**
 * 
 * @export
 * @interface NotificationEventTopicRoute
 */
export interface NotificationEventTopicRoute {
    /**
     * The event-topic route ID.
     * @type {string}
     * @memberof NotificationEventTopicRoute
     */
    id: string;
    /**
     * 
     * @type {NotificationEventType}
     * @memberof NotificationEventTopicRoute
     */
    eventType: NotificationEventType;
    /**
     * The ID of the topic to route events to.
     * @type {string}
     * @memberof NotificationEventTopicRoute
     */
    topicId: string;
    /**
     * The Ampersand project ID.
     * @type {string}
     * @memberof NotificationEventTopicRoute
     */
    projectId: string;
    /**
     * The time when the event-topic route was created.
     * @type {Date}
     * @memberof NotificationEventTopicRoute
     */
    createTime: Date;
    /**
     * The time when the event-topic route was last updated.
     * @type {Date}
     * @memberof NotificationEventTopicRoute
     */
    updateTime?: Date;
}

/**
 * Check if a given object implements the NotificationEventTopicRoute interface.
 */
export function instanceOfNotificationEventTopicRoute(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "eventType" in value;
    isInstance = isInstance && "topicId" in value;
    isInstance = isInstance && "projectId" in value;
    isInstance = isInstance && "createTime" in value;

    return isInstance;
}

export function NotificationEventTopicRouteFromJSON(json: any): NotificationEventTopicRoute {
    return NotificationEventTopicRouteFromJSONTyped(json, false);
}

export function NotificationEventTopicRouteFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationEventTopicRoute {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'eventType': NotificationEventTypeFromJSON(json['eventType']),
        'topicId': json['topicId'],
        'projectId': json['projectId'],
        'createTime': (new Date(json['createTime'])),
        'updateTime': !exists(json, 'updateTime') ? undefined : (new Date(json['updateTime'])),
    };
}

export function NotificationEventTopicRouteToJSON(value?: NotificationEventTopicRoute | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'eventType': NotificationEventTypeToJSON(value.eventType),
        'topicId': value.topicId,
        'projectId': value.projectId,
        'createTime': (value.createTime.toISOString()),
        'updateTime': value.updateTime === undefined ? undefined : (value.updateTime.toISOString()),
    };
}

